/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferOrderRefreshOptionEnum = 'Nach15Tagen' | 'Alle30Tage' | 'Alle7Tage' | 'Alle3Tage';

export const OfferOrderRefreshOptionEnum = {
    Nach15Tagen: 'Nach15Tagen' as OfferOrderRefreshOptionEnum,
    Alle30Tage: 'Alle30Tage' as OfferOrderRefreshOptionEnum,
    Alle7Tage: 'Alle7Tage' as OfferOrderRefreshOptionEnum,
    Alle3Tage: 'Alle3Tage' as OfferOrderRefreshOptionEnum
};

